"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ikeaSharedComponent = require("@ikea-aoa/ikea-shared-component");

var _ImageEjs = _interopRequireDefault(require("./Image.ejs.js"));

var _ImageUtility = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/ImageUtility"));

require("./Image.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var RIC_REGEXP = /(_[sS])[1-5]\./;
/**
 * This component should be used to get images from akamai.
 *
 * @example
 * <ikea-component name="Image" data-src="/img/my-image.jpg"></ikea-component>
 * @example
 * <Image src="/img/my-image.jpg"></Image>
 */

var Image = /*#__PURE__*/function (_AbstractComponent) {
  _inherits(Image, _AbstractComponent);

  var _super = _createSuper(Image);

  /**
   * Class constructor.
   *
   * @param {Element} element The associated element.
   */
  function Image(element) {
    var _this;

    _classCallCheck(this, Image);

    _this = _super.call(this, element);
    _this.img = null;
    _this.src = null;
    _this.queryString = null;
    _this.size = 0;
    _this.isRic = false;
    _this.isLoading = false;
    return _this;
  }
  /**
   * Triggered when the component is loaded the first time.
   *
   * @override
   */


  _createClass(Image, [{
    key: "load",
    value: function load() {
      this.resizeHandler.on('resize', this._handleResize.bind(this));
    }
    /**
     * Triggered when props has changed.
     *
     * @param {object} newProps New props.
     */

  }, {
    key: "propsHasChanged",
    value: function propsHasChanged(newProps) {
      if (newProps.src !== undefined) {
        this._updateSource();
      }
    }
    /**
     * Gets the template.
     *
     * @override
     * @returns {Function} Template parse function.
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      // Removes image, so that the load element will be triggered
      if (this.isLoading && this.element.children[0] && this.element.children[0].children[0]) {
        this.element.children[0].removeChild(this.element.children[0].children[0]);
      }

      return _ImageEjs.default;
    }
    /**
     * Handles image load.
     *
     * @param {Event} event Event object.
     */

  }, {
    key: "handleImageLoad",
    value: function handleImageLoad(event) {
      if (event.currentTarget.parentElement) {
        event.currentTarget.parentElement.classList.remove('Image--loading');
      }
    }
    /**
     * Updates source data.
     */

  }, {
    key: "_updateSource",
    value: function _updateSource() {
      var src = this._parseSource(this.props.src);

      var isRic = src.match(RIC_REGEXP) !== null || this.props.ric;

      var size = this._getImageSize(isRic);

      if (size > this.size || src !== this.src) {
        var queryString = _ImageUtility.default.getAkamaiQueryString(size);

        if (src !== this.src || queryString !== this.queryString) {
          this.isRic = isRic;
          this.isLoading = src && src !== this.src;
          this.size = size;
          this.src = src;
          this.queryString = queryString;
        }
      }
    }
    /**
     * Handles a resize.
     */

  }, {
    key: "_handleResize",
    value: function _handleResize() {
      var size = this._getImageSize(this.isRic);

      if (size > this.size) {
        var queryString = _ImageUtility.default.getAkamaiQueryString(size);

        if (queryString !== this.queryString) {
          this.size = size;
          this.queryString = queryString;
          this.img = this.img || this.element.children[0].children[0];
          this.img.setAttribute('src', this.src + this.queryString);
        }
      }
    }
    /**
     * Returns the image size.
     *
     * @param {boolean} isRic TRUE if RIC.
     * @returns {number} Image size.
     */

  }, {
    key: "_getImageSize",
    value: function _getImageSize(isRic) {
      return isRic ? this.element.offsetWidth * 1.14 : this.element.offsetWidth;
    }
    /**
     * Parses source.
     *
     * @param {string} src Source.
     * @returns {string} Source.
     */

  }, {
    key: "_parseSource",
    value: function _parseSource(src) {
      return src.replace(RIC_REGEXP, "$15.");
    }
    /**
     * Returns the supported props.
     *ƒ
     * @override
     * @example [
     *  new SupportedProp('requiredProp', 'string', true),
     *  new SupportedProp('optionalProp', 'number')
     * ]
     * @summary
     * src: The source of the image.
     * alt: Alternative text description of the image.
     * ric: Handle the image as a RetailItemComm image. The image will automatically be considered as RIC if the URL ends with a RIC format (S1, S2, S3 etc.).
     * @returns {SupportedProp[]} Supported prop objects.
     */

  }], [{
    key: "supportedProps",
    get: function get() {
      return [new _ikeaSharedComponent.SupportedProp('src', 'string', true), new _ikeaSharedComponent.SupportedProp('alt', 'string', false, null, ''), new _ikeaSharedComponent.SupportedProp('ric', 'boolean', false, null, false)];
    }
    /**
     * Returns the component name.
     *
     * @override
     * @returns {string} Component name.
     */

  }, {
    key: "componentName",
    get: function get() {
      return 'Image';
    }
  }]);

  return Image;
}(_ikeaSharedComponent.AbstractComponent);

exports.default = Image;